var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-9 0 274 274",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M191.54779,186.292389 L191.607285,246.81213 L137.903038,273.611369 L137.903038,213.11807 L191.54779,186.292389 Z M256.000818,153.946885 L256.000818,214.678164 L210.196199,237.537504 L210.163146,177.083869 L256.000818,153.946885 Z M191.468463,105.286501 L191.527958,165.171627 L137.903038,191.818823 L137.903038,131.913865 L191.468463,105.286501 Z M256.000818,73.2054191 L256.000818,132.713743 L210.149925,156.022603 L210.110262,96.0184858 L256.000818,73.2054191 Z M129.738988,66.1651652 L177.67221,90.3598405 L127.940914,115.334563 L80.9133402,91.7150067 L129.738988,66.1651652 Z M63.0648093,32.5107686 L108.783491,55.588258 L59.8454631,81.1314889 L12.8906057,57.5515964 L63.0648093,32.5107686 Z M193.755719,32.8611286 L242.997833,57.5515964 L198.958235,79.6705536 L150.925855,55.4428255 L193.755719,32.8611286 Z M128.231779,3.55271368e-15 L172.562241,22.2247263 L130.056295,44.9188028 L84.3772773,21.8809768 L128.231779,3.55271368e-15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.943932,131.913865 L82.7709095,113.728195 L82.7709095,192.334447 C82.7709095,192.334447 38.5329951,98.2065835 34.4344436,89.7516683 C33.9055982,88.6609247 31.7307216,87.4644121 31.175434,87.1735472 C23.2427536,83.0088899 0,71.2354701 0,71.2354701 L0,210.110262 L32.1537979,227.297736 L32.1537979,154.7071 C32.1537979,154.7071 75.9223621,238.813344 76.3652701,239.732213 C76.8081781,240.651081 81.2042052,249.515852 85.8977077,252.629429 C92.1513041,256.767644 118.950543,272.884206 118.950543,272.884206 L118.943932,131.913865 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpy);
export default __webpack_public_path__ + "static/media/numpy.324aa0389bb00e83354959745dd9b8f0.svg";
export { ForwardRef as ReactComponent };